import styled, { createGlobalStyle } from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledSkeletonLoaderContainer = styled.div`
  @media ${theme.mediaQuery.largeMobile} {
    padding-right: 0;
    padding-left: 0;
  }
  .map-loader {
    flex-flow: wrap;
    height: auto;
  }
`;

export const StyledSkeletonLoaderDiv = styled.div`
  .right-side-loader {
    padding-left: ${toRem(15)};
  }


    border-radius: ${toRem(14)};
    height: ${toRem(285)};
    margin: ${toRem(10)} 0;
    font-family: ${theme.fonts['fontFamilySwiss']};
    display: flex;
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    background-color: ${theme.color['white']};
      @media ${theme.mediaQuery.allMobiles} {
        flex-flow:wrap;
         height: auto;
      }
    .left-side-loader {
      width:45%;
      @media ${theme.mediaQuery.allMobiles} {
        width:100%;
        min-height:${toRem(200)}
      }
      .image-place-loader {
        border-top-left-radius:${toRem(10)};
        border-bottom-left-radius:${toRem(10)};
         @media ${theme.mediaQuery.allMobiles} {
            border-radius:${toRem(10)};
            border-top-left-radius:${toRem(10)};
            border-top-right-radius:${toRem(10)};
            border-bottom-right-radius:${toRem(0)};
            border-bottom-left-radius:${toRem(0)};
          }
      }
    }
      .map-loader-left {
        width:100%;
        min-height:${toRem(200)};
        .image-place-loader {
            border-radius:${toRem(10)};
            border-top-left-radius:${toRem(10)};
            border-top-right-radius:${toRem(10)};
            border-bottom-right-radius:${toRem(0)};
            border-bottom-left-radius:${toRem(0)};
        }
      }
    .skeleton-loader-composite {
      background-color: ${theme.color['light-gray-1']};
      color: white;
      -webkit-animation: fadein 2s ease-in alternate infinite;
      -moz-animation: fadein 2s ease-in alternate infinite;
      animation: fadein 2s ease-in alternate infinite;
    }
    @-webkit-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @-moz-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    .right-side-loader {
      padding-right: ${toRem(15)};
      padding-top: ${toRem(20)};
      padding-bottom: ${toRem(20)};
      width:55%;
      @media ${theme.mediaQuery.allMobiles} {
        width:100%;
        padding-right: ${toRem(15)};
      }
        .top-right-side-loader {
          width:90%;
          @media ${theme.mediaQuery.allMobiles} {
            width:100%;
          }
        }
        .bottom-rate-place-loader-container {
          width:90%;
          display: flex;
          justify-content: flex-end;
          .rate-place-loader {
            border-radius: ${toRem(22)};
          }
           @media ${theme.mediaQuery.allMobiles} {
            width:100%;
            .rate-place-loader {
              width:40%
            }
          }
        }
      }
    }
      .map-loader-right {
        width:100%;
        padding-right: ${toRem(15)};
         .top-right-side-loader {
            width:100%;
        }
        .bottom-rate-place-loader-container {
            width:100%;
            .rate-place-loader {
              width:40%
            }
          }
      }

`;

export const StyledSkeletonMapViewLoaderDiv = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);

  .map-view-loader {
    padding: ${toRem(10)};
    border-radius: ${toRem(12)};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #universal-footer {
    display: none;
  }
`;

export const StyledMapViewSkeletonLoader = styled.div<{ windowHeight: number; offsetHeight: number }>`
  position: relative;
  background-color: ${baseVariables.color.base20};
  height: ${props => `${Math.max(0, Math.round((props?.windowHeight || 0) - (props?.offsetHeight || 0)))}px`};
  overflow: hidden;

  .search-results-list-loader {
    min-width: ${toRem(380)};
    width: ${toRem(380)};
    overflow-y: scroll;
    box-shadow: 0px ${toRem(7)} ${toRem(20)} 0px rgba(0, 0, 0, 0.25);
    // border-right: 1px solid rgba(238, 238, 238, 1);
    display: none;

    @media ${baseVariables.mediaQuery.xl} {
      display: block;
    }
  }

  .search-results-map-loader {
    width: 100%;
  }

  .loadStyle {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;

    @media ${baseVariables.mediaQuery.xl} {
      left: 60%;
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }

  .search-page-container {
    min-height: unset !important;
  }

  #universal-footer {
    display: none;
  }
`;
